import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';

import Text from 'common/Text';

const useStyles = makeStyles(({ theme }) => ({
    descriptionGivenAfterPurchase: {
        '& p': {
            margin: theme.spacing(0, 0, 2, 0)
        },
        '& ul': {
            margin: theme.spacing(0, 0, 2, 0)
        },
        '& :last-child': {
            marginBottom: theme.spacing(0)
        },
        '& h4': {
            margin: theme.spacing(4, 0, 2, 0)
        },
        '& :first-child': {
            marginTop: theme.spacing(0)
        },
    }
}));

const DescriptionGivenAfterPurchase = ({ booking }) => {
    const classes = useStyles();

    return (
        <Text className={classes.descriptionGivenAfterPurchase} html={booking.descriptionGivenAfterPurchase} ignoreNewlines/>
    );
};

DescriptionGivenAfterPurchase.propTypes = {
    booking: PropTypes.object.isRequired
};

export default DescriptionGivenAfterPurchase;
